import toNumber from 'lodash/toNumber';
export const _toNumber = toNumber;
